import authenticate from "@/auth/authenticate";

export default [
  {
    path: "/auth",
    name: "auth",
    component: () => import("@/views/global/Clear"),
    children: [
      {
        path: "",
        name: "auth.signIn",
        component: () => import("@/views/home/SignIn"),
      },
    ],
  },
];
